<template>
  <section class="index-wrap">
    <el-col class="content" :span="18">
      <div class="u-com-box">
        <!-- 我的积分 -->
        <div class="item-left">
          <h1 class="com-title"><span class="bd"></span>我的积分</h1>
          <div class="item">
            <div>剩余积分</div>
            <div class="integer">
              <p>{{modelZZ.currentPoint}}</p>
              <div style="border-top:1px solid #eee;margin:10px 0"></div>
              <el-button size="mini" @click="dialogZZ=true">转赠</el-button>
              <el-button size="mini" type="primary" v-if="$store.getters.rechargeButton === 1"
                @click="topUp">充值</el-button>
            </div>
          </div>
        </div>
        <!-- 我的收益 -->
          <div  class="item-right">
            <h1 class="com-title"><span class="bd"></span>我的收益</h1>
            <div class="box">
                <p>收益总额</p>
                <p>{{userPayInfoTotal}} 元</p>
            </div>
          </div>
      </div>

      <div class="com-box center mg30">
        <h1 class="com-title"><span class="bd"></span>客户预览</h1>
        <div class="chart-box-wrap">
          <template v-show="!chartKH.noData">
            <div class="chart-box" id="chartKH"></div>
          </template>
        </div>
      </div>

      <div class="com-box bottom mg30">
        <h1 class="com-title"><span class="bd"></span>收益预览</h1>
        <div class="chart-box-wrap">
          <template v-show="!chartSY.noData">
            <div v-show="!chartSY.noData" class="chart-box" id="chartSY"></div>
          </template>
        </div>
      </div>
    </el-col>
    <el-col class="right-content" :span="6">
      <div class="com-box" style="padding: 15px">
        <div class="felx-betwwen"><p  class="com-title">
          <span class="bd"></span>
              积分明细
            </p>
            <div><a
              @click="
                  $router.push({
                    path: '/invite/pointHistory.html',
                    query: { userId: $store.getters.userId },
                  })
                "
            >更多<i class="el-icon-d-arrow-right"></i
            ></a></div></div>
        
        <div class="box">
          <div class="b2">
            <ul>
              <li class="title">
                <span>操作时间</span><span>变动积分</span><span>变动类型</span>
              </li>
              <ul class="con">
                <div v-if="integralList.length > 0">
                  <li v-for="(item, index) in integralList" :key="index">
                    <span>{{ item.pointTime | formatDate }}</span
                    ><span>{{ item.point }}</span
                  ><span>{{ item.typeDesc }}</span>
                  </li>
                </div>
                <no-data v-else/>
              </ul>
            </ul>
          </div>
        </div>
      </div>
      <div class="com-box" style="padding: 15px;margin-top:15px">
        <div class="felx-betwwen"><p  class="com-title">
          <span class="bd"></span>
              充值明细
            </p>
            <div><a
              @click="
                  $router.push({
                    path: '/pages/myProfit.html',
                    query: { userId: $store.getters.userId },
                  })
                "
            >更多<i class="el-icon-d-arrow-right"></i
            ></a></div></div>
        
        <div class="box">
          <div class="b2">
            <ul>
              <li class="title">
                <span>用户名称</span>
                <span>订单金额</span>
              </li>
              <ul class="con">
                <div v-if="pageListData.length > 0">
                  <li v-for="(item, index) in pageListData" :key="index">
                    <span>{{ item.name }}</span
                  ><span>{{ item.money }}</span>
                  </li>
                </div>
                <no-data v-else/>
              </ul>
            </ul>
          </div>
        </div>
      </div>
    </el-col>
    <!-- 转赠积分 -->
    <el-dialog
      custom-class="com-dialog"
      :show-close="false"
      title="转赠积分"
      :visible.sync="dialogZZ"
      :close-on-click-modal="false"
    >
      <div>
        <el-form
          :model="modelZZ"
          :rules="rulesZZ"
          ref="ruleFormZZ"
          label-width="100px"
          class="dialog-form"
        >
          <el-form-item label="转赠账号：" prop="name">
            <el-input v-model="modelZZ.userAccount" placeholder="电话/账号"/>
          </el-form-item>
          <el-form-item label="当前积分：" prop="name">
            <span class="normal">{{ modelZZ.currentPoint }}</span>
          </el-form-item>
          <el-form-item label="转赠积分：" prop="point">
            <el-input
              v-model.number="modelZZ.point"
              placeholder="请输入"
              type="number"
            />
          </el-form-item>
        </el-form>
        <div class="footer" slot="footer">
          <el-button @click="dialogZZ = false">取 消</el-button>
          <el-button type="primary" @click="submitFormZZ('ruleFormZZ')"
          >确 定
          </el-button
          >
        </div>
      </div>
    </el-dialog>
    <!-- 提现 -->
    <el-dialog
      custom-class="com-dialog"
      :show-close="false"
      title="申请提现"
      :visible.sync="dialogTX"
      :close-on-click-modal="false"
    >
      <div>
        <el-form
          :model="modelTX"
          :rules="rulesTX"
          ref="ruleFormTX"
          label-width="100px"
          class="dialog-form"
        >
          <el-form-item label="开户名称：" prop="userName">
            <span>{{ $store.getters.userName }}</span>
          </el-form-item>
          <el-form-item label="开户银行：" prop="bankName">
            <el-input
              v-model.number="modelTX.bankName"
              placeholder="开户银行"
            />
          </el-form-item>
          <el-form-item label="银行账号：" prop="bankNo">
            <el-input
              v-model="modelTX.bankNo"
              placeholder="银行账号"
              type="number"
            />
          </el-form-item>
          <el-form-item label="提现金额：" prop="name">
            <span>{{ noApplyIncomeTotal | money }}</span>
            <!-- <el-input v-model.number="modelTX.point" placeholder="单次提现最低200元" type="number" /> -->
          </el-form-item>
        </el-form>
        <div class="footer" slot="footer">
          <el-button @click="dialogTX = false">取 消</el-button>
          <el-button
            type="primary"
            @click="submitFormTX('ruleFormTX')"
            :loading="loadingTX"
            :disabled="loadingTX"
          >确 定
          </el-button>
        </div>
      </div>
    </el-dialog>
  </section>
</template>

<script>
  import http from "@/http";
  import Clipboard from "clipboard";

  export default {
    data() {
      return {
        apiUserCnt: "",
        spreadUserCnt: "",
        isActive: true,
        scene: 2, //2君子签 5:微版权
        chartKH: {
          instance: "",
          noData: false,
          active: "", // 当前选择
        },
        chartSY: {
          instance: "",
          noData: false,
          active: "", // 当前选择
        },
        chartDataCustomerPreview: {
          color: [["#10C0FD", "#80EAFF"]],
          name: [],
          chartTitle: [],
          chartDataBZ: [],
          chartDataDZ: [],
        },
        chartDataProfitPreview: {
          color: ["#FFB848", "#00B1FF"],
          name: ["收益"],
          chartTitle: [],
          chartDataBZ: [],
          chartDataDZ: [],
        },
        // 转赠积分
        loadingZZ: false,
        dialogZZ: false,
        modelZZ: {
          userAccount: "",
          currentPoint: "", // 当前积分
          point: "", // 转赠积分
        },
        rulesZZ: {
          point: [
            {
              // type: 'integer',
              required: true,
              message: "请输入转赠积分",
            },
            {
              validator: this.$validatorInteger,
              trigger: "blur",
            },
          ],
        },
        // 提现
        loadingTX: false,
        dialogTX: false,
        modelTX: {
          ts: "",
          applySettleNo: "",
          bankName: "",
          bankNo: "",
        },
        rulesTX: {
          bankName: [
            {
              required: true,
              message: "请输入开户银行",
              trigger: "change",
            },
          ],
          bankNo: [
            {
              required: true,
              message: "银行账号",
              trigger: "change",
            },
            {
              validator: this.$bankCard,
              trigger: "blur",
            },
          ],
        },
        showWithDraw: false,
        // 充值明细
        pageListData:[],
        // 积分明细
        integralList: [],
        // 我的收益
        incomeTotal: "",
        // 收益总额
        userPayInfoTotal:'',
        Withdrawn: "", // 已提现
        noApplyIncomeTotal: "", // 剩余收益
        // 链接地址
        linkQr: "",
        dzcpsy: "", //定制产品收益
        //  956需求修改
        optionIncoming: {
          tooltip: {
            trigger: 'axis',
            textStyle: {
              align: 'left',
            },
          },
          legend: {
            left: "5%",
            top: "5%",
            data: []
          },
          grid: {
            top: "24%",
            left: "5%",
            bottom: "25%",
            right: "5%",
            containLabel: true,
          },
          dataZoom: [
            {
              type: 'inside',
              start: 50,
              end: 100
            },
            {
              start: 50,
              end: 100
            }
          ],
          xAxis: {
            type: 'category',
            boundaryGap: false,
            data: [],
            axisLabel: {
              interval: 0,
              rotate: 0,
              textStyle: {
                fontSize: 10, //更改坐标轴文字大小
                color: "#022F4A",
              },
              axisTick: {
                show: false,
              },
              axisLine: {
                show: true,
                lineStyle: {
                  color: "#EEEEEE",
                },
              },
              formatter: function (value) {
                let index = value.indexOf('至')
                let str = ''
                if (index !== -1) {
                  str = value.slice(0, index) + '\n' + value.slice(index + 1)
                } else {
                  str = value
                }
                return str
              }
            }
          },
          yAxis: {
            type: 'value',
            splitLine: {
              show: false,
            },
            axisLine: {
              show: true,
              lineStyle: {
                color: "#EEEEEE",
              },
            },
            axisTick: {
              show: false,
            },
            axisLabel: {
              textStyle: {
                color: "#022F4A",
              },
            },
          },
          series: []
        },
        optionUser: {
          tooltip: {
            trigger: 'axis',
            axisPointer: {
              type: "shadow",
              shadowStyle: {
                opacity: 0.5,
              },
            },
            textStyle: {
              align: 'left',
            },
          },
          textStyle: {
            align: 'left',
          },
          legend: {
            left: "5%",
            top: "5%",
            data: []
          },
          grid: {
            top: "24%",
            left: "5%",
            bottom: "25%",
            right: "5%",
            containLabel: true,
          },
          dataZoom: [
            {
              type: 'inside',
              start: 50,
              end: 100
            },
            {
              start: 50,
              end: 100
            }
          ],
          xAxis: {
            type: 'category',
            data: [],
            axisLabel: {
              textStyle: {
                fontSize: 10, //更改坐标轴文字大小
                color: "#022F4A",
              },
              formatter: function (value) {
                let index = value.indexOf('至')
                let str = ''
                if (index !== -1) {
                  str = value.slice(0, index) + '\n' + value.slice(index + 1)
                } else {
                  str = value
                }
                return str
              }
            },
            axisTick: {
              show: false,
            },
            axisLine: {
              show: true,
              lineStyle: {
                color: "#EEEEEE",
              },
            },
          },
          yAxis: {
            minInterval: 1,
            splitLine: {
              show: false,
            },
            axisLine: {
              show: true,
              lineStyle: {
                color: "#EEEEEE",
              },
            },
            axisTick: {
              show: false,
            },
            axisLabel: {
              textStyle: {
                color: "#022F4A",
              },
            },
            type: 'value'
          },
          series: []
        },

        defenseNoticeData:null
      };
    },
    mounted() {
      this.getInfoUserData(3)
      this.getInfoIncomingData(3)
      // 查询当前登录用户积分
      this.searchIntegral();
      // 获取积分明细
      this.getIntegral();
      // 获取我的收益
      this.getMyProfit();
      // 获取收益总额
      this.getuserPayInfoTotal()
      // 获取充值明细
      this.queryList()
      // 获取提现信息
      this.getWithDrawInfo();
      // 获取链接
      this.getLink();
      this.getMyUserNum();
      this.getIncomeSum();
      // ***
      this.openNoticeDialog();
    },
    beforeDestroy() {
      this.defenseNoticeData && this.defenseNoticeData.close();
    },
    methods: {
      getInfoUserData(active = 3) {
        //  /statistics/user
        let inviteFlag = (this.chartKH.active = active);
        // inviteFlag 0 按日统计 1 按周统计 2 按月统计
        this.chartKH.noData = false;
        http.post(this.globalConfig.domain.backstage + "/statistics/user",
          {sd: inviteFlag}, (response) => {
            let result = response.data.data;
            if (response.data.success) {
              let list = result.lineData.series
              let arr = list.map(v => {
                return v.name
              })
              let lineList = list.map(v => {
                if (v.name=='标准产品客户') {
                  return {
                    name: v.name,
                    type: 'bar',
                    smooth: true,
                    barWidth: '10%',
                    data: v.data,
                    itemStyle: {
                      color: v.name === '标准产品客户' ? '#0DB5FF' : '#22E1C4',
                      barBorderRadius: [8, 8, 0, 0],
                    },
                    emphasis: {
                      itemStyle: {
                        opacity: 0.8,
                      },
                    },
                  }
                } 
              })
              this.optionUser.xAxis.data = result.lineData.xaxis
              this.optionUser.legend.data = arr
              this.optionUser.series = lineList
              this.drawBarChart()
            }
          }
        );
      },
      getInfoIncomingData(active = 3) {
        let inviteFlag = (this.chartSY.active = active);
        // inviteFlag 0 按日统计 1 按周统计 2 按月统计
        this.chartSY.noData = false;
        http.post(this.globalConfig.domain.backstage + "/statistics/payInfo",
          {sd: inviteFlag}, (response) => {
            let result = response.data.data;
            if (response.data.success) {
              let list = result.lineData.series
              let arr = list.map(v => {
                return v.name
              })
              let data = list.map(v => {
                  return {
                  name: v.name,
                  type: 'line',
                  smooth: true,
                  data: v.data,
                  symbolSize: 6,
                  symbol: "circle",
                  itemStyle: {
                    color: v.name === '收益' ? '#9880EF' : '#FBA0A0',
                    borderType: "solid",
                  }
                }
              })
              this.optionIncoming.xAxis.data = result.lineData.xaxis
              this.optionIncoming.legend.data = arr
              this.optionIncoming.series = data
              this.drawLineChart()
            }
          }
        );
      },
      changeEWMTab(v) {
        v == 2 && (this.isActive = true);
        v == 5 && (this.isActive = false);
        this.scene = v;
        this.getLink();
      },

      topUp() {
        window.open(
          "https://account.ebaoquan.org/login/loginPage?returnURL=" +
          encodeURIComponent(
            "https://account.ebaoquan.org/asset/pointChargePage"
          ),
          "_blank"
        );
      },
      // 获取地址链接
      getLink() {
        let _this = this;
        http.post(
          this.globalConfig.domain.backstage + "/common/uiqrUrl",
          {scene: this.scene},
          (response) => {
            let result = response.data;
            if (result.success) {
              _this.linkQr = result.data;
            }
          }
        );
      },
      // 获取积分明细
      getIntegral() {
        let _this = this;
        let param = {
          page: 1,
          pageSize: 10,
          userId: this.$store.getters.userId,
        };
        http.post(
          this.globalConfig.domain.backstage +
          "/point/queryPointHistoryByCondition",
          param,
          (response) => {
            _this.loading = false;
            let result = response.data;
            if (result.success) {
              _this.integralList = result.data.listData;
            }
          }
        );
      },
      // 获取提现信息
      getWithDrawInfo() {
        http.post(
          this.globalConfig.domain.backstage + "/settle/applySettlePre",
          {},
          (response) => {
            let result = response.data;
            if (result.success) {
              this.showWithDraw = !!result.data.applySettleFlag;
              this.modelTX.ts = result.data.ts;
              this.modelTX.applySettleNo = result.data.applySettleNo;
            }
          }
        );
      },
      // 获取充值明细
      queryList() {
			  let _this = this;
        let param = {
          name:'',
          payTimeStart:'',
          payTimeEnd:'',
          page: 1,
          pageSize: 10,
          userId: _this.$store.getters.userId,
        };
				http.post(_this.globalConfig.domain.backstage + "/admin/queryUserPayInfo", param, (response) => {
					let result = response.data;
					if (result.success) {
						_this.pageListData = result.data.listData;
						_this.paged = result.data.paged;
					} else {
						_this.$message.error(result.message);
					}
				});
			},
      // 获取收益总额
      getuserPayInfoTotal(){
        http.post(
          this.globalConfig.domain.backstage + "/admin/userPayInfoTotal",
          {},
          (response) => {
            let {data:res}=response
            if (res.success) {
              this.userPayInfoTotal = res.data.total || '--';
            }
          }
        );
      },
      // 获取我的收益
      getMyProfit() {
        http.post(
          this.globalConfig.domain.backstage + "/settle/querySettleTotal",
          {},
          (response) => {
            let result = response.data;
            if (result.success) {
              this.incomeTotal = result.data.incomeTotal;
              this.noApplyIncomeTotal = result.data.noApplyIncomeTotal;
              this.Withdrawn =
                result.data.incomeTotal - result.data.noApplyIncomeTotal;
            }
          }
        );
      },

      //获取我的用户数量
      getMyUserNum() {
        let _this = this
        http.post(_this.globalConfig.domain.backstage + "/admin/queryUserInvite", {
          page: 1,
          pageSize: 10
        }, (response) => {
          let result = response.data;
          if (result.success) {
            this.spreadUserCnt = result.data.paged.total;
          } else {
            _this.$message.error(result.message);
          }
        });
        http.post(
          this.globalConfig.domain.backstage + "/admin/statisticsUserCnt",
          {},
          (response) => {
            let result = response.data;
            if (result.success) {
              this.apiUserCnt = result.data.apiUserCnt;
            }
          }
        );
      },

      //获取定制产品收益
      getIncomeSum() {
        http.post(
          this.globalConfig.domain.backstage + "/custom/product/income/sum",
          {},
          (response) => {
            let result = response.data;
            if (result.success) {
              this.dzcpsy = result.data;
            }
          }
        );
      },

      // 复制
      copyText() {
        const clipboard = new Clipboard("#tag-copy");
        clipboard.on("success", (e) => {
          this.$message({
            type: "success",
            message: "复制成功",
          });
          // 释放内存
          clipboard.destroy();
        });
        clipboard.on("error", (e) => {
          // 不支持复制
          this.$message({
            type: "waning",
            message: "该浏览器不支持自动复制",
          });
          // 释放内存
          clipboard.destroy();
        });
      },
      // 查询当前登录用户积分
      searchIntegral() {
        var _this = this;
        http.get(
          _this.globalConfig.domain.backstage + "/admin/queryUserById",
          (response) => {
            if (response.data && response.data.success) {
              _this.modelZZ.currentPoint = response.data.data.point;
            }
          }
        );
      },
      // 转赠积分提交
      submitFormZZ(formName) {
        var _this = this;
        this.$refs[formName].validate((valid) => {
          if (valid) {
            _this.loadingZZ = true;
            let param = {
              point: _this.modelZZ.point,
              userAccount: _this.modelZZ.userAccount,
            };
            http.post(
              _this.globalConfig.domain.backstage + "/admin/sendUserPoint",
              param,
              (response) => {
                _this.loadingZZ = false;
                if (response.data && response.data.success) {
                  _this.$message.success("操作成功");
                  this.dialogZZ = false;
                  // 清空表单
                  _this.modelZZ = {
                    ..._this.modelZZ,
                    point: "",
                    userAccount: "",
                  };
                  this.searchIntegral();
                  // _this.modelZZ.currentPoint = response.data.data.point
                } else {
                  _this.$message.success(response.data.message);
                }
              }
            );
          } else {
            console.log("error submit!!");
            return false;
          }
        });
      },
      // 提现
      submitFormTX(formName) {
        this.$refs[formName].validate((valid) => {
          if (valid) {
            this.loadingTX = true;
            let param = {
              ...this.modelTX,
            };
            http.post(
              this.globalConfig.domain.backstage + "/settle/applySettle",
              param,
              (response) => {
                this.loadingTX = false;
                if (response.data && response.data.success) {
                  this.$message.success(response.data.message || "提现成功");
                  this.dialogTX = false;
                  this.getMyProfit();
                } else {
                  this.$message.error(response.data.description);
                }
              }
            );
          } else {
            console.log("error submit!!");
            return false;
          }
        });
      },
      drawLineChart() {
        let dom = document.getElementById('chartSY')
        if (!dom) return;
        const myChart = this.$echarts.init(dom)
        myChart.setOption(this.optionIncoming)
      },
      drawBarChart() {
        let dom = document.getElementById('chartKH')
        if (!dom) return;
        const myChart = this.$echarts.init(dom)
        myChart.setOption(this.optionUser)
      },

      //套餐告警用户弹窗
      openNoticeDialog() {
        let _this = this;
        let param = {
          merchantAccount: '',
          merchantName:'',
          warning:'1',
          pageSize: 10,
          page: 1
        };
        http.post(_this.globalConfig.domain.backstage + "/sellerMerchant/querySellerMerchantList",param, (response) => {
          let result = response.data;
          if (result.success && result.data.listData.length) {
            this.defenseNoticeData && this.defenseNoticeData.close();
            const h = this.$createElement;
            this.defenseNoticeData = this.$notify({
              title: '套餐告警',
              dangerouslyUseHTMLString: true,
              message: h('p', null, [
                '系统检测到客户套餐余量不足或即将到期，请及时联系客户跟进续费。',
                // h('p',
                //   [
                //     h('el-button', {
                //       style: {
                //         float: 'right',
                //         margin: '20px 0 0 10px'
                //       },
                //       attrs: {
                //         size: 'mini',
                //         type: 'primary'
                //       },
                //       on: {
                //         click: this.goTO
                //       }
                //     }, '查看告警')
                //   ]
                // )
              ]),
              duration: 0,
              customClass: 'defenseNoticeDialog',
              position: 'bottom-right',
              onClose: function () {
              }
            })
          }
        });
      },
      goTO(){
          this.defenseNoticeData.close();
          this.$router.push({
            name:'定制产品客户',
            params: {
              isMainPages:'Y'
            }
          });
      }
    },
  };
</script>
<style scoped lang="scss">
  .u-com-box{
    display: flex;
    justify-content: space-between;
    >div{
      width:48%;
      height: 20vh;
      background-color: #fff;
      border-radius: 5px;
    }
    .item-left{
      .item{
        padding: 10px;
        display: flex;
        flex-direction:column;
        align-items: flex-start;
        .integer{
          margin: 0 auto;
          padding-top: 15px;
          > p {
            color: #02a7f0;
            font-size: 32px;
            font-weight: bold;
            margin-bottom: 15px;
          }
        }
      }
    }
    .item-right{
      .box{
        padding: 10px;
        display: flex;
        flex-direction: column;
        align-items: flex-start;

        > p:last-child{
            color: #02a7f0;
            font-size: 32px;
            font-weight: bold;
            margin: 0 auto;
            margin-top: 15px;
        }
      }
    }
  }
// 以下是原来的
  /deep/ .el-menu-item-group__title {
    padding: 0;
  }

  .mg25 {
    margin-top: 25px;
  }

  .mg30 {
    margin-top: 30px;
  }

  .zz {
    font-size: 14px;
    font-family: PingFang SC;
    font-weight: 400;
    line-height: 25px;
    color: rgba(0, 177, 255, 1);
    width: 100px;
    padding: 0;
    border: 1px solid rgba(0, 177, 255, 1);
    border-radius: 2px;
  }

  .cz {
    background-color: #00b1ff;
    font-size: 14px;
    font-family: PingFang SC;
    font-weight: 400;
    line-height: 25px;
    color: #ffffff;
    width: 100px;
    padding: 0;
    border: 1px solid rgba(0, 177, 255, 1);
    border-radius: 2px;
  }

  .index-wrap {
    /*width: 100%;*/
    position: relative;
    display: flex;
    justify-content: space-between;
    // align-items: center;

    $rwidth: 300px;

    .content {
      flex: auto;
      margin-right: 30px;
      height: 100%;

      .top {
        .box {
          display: flex;
          justify-content: space-between;
          align-items: center;
          box-sizing: border-box;
          padding: 33px 10px 12px 0;
        }

        .one {
          display: flex;
          justify-content: space-between;
          align-items: center;

          > img {
            width: 60px;
            height: 60px;
            margin-left: 40px;
          }

          > div {
            box-sizing: border-box;
            width: 230px;
            padding-left: 40px;
            flex: auto;
            color: #022f4a;
            text-align: left;

            p:first-child {
              font-size: 16px;
              font-family: PingFang SC;
              font-weight: 400;
              // padding-left: 15px;
            }

            p:nth-child(2) {
              margin-left: -5px;
              font-size: 32px;
              font-family: Arial;
              font-weight: bold;
              line-height: 53px;
            }

            > a {
              cursor: pointer;
              margin-bottom: 2px;
              // margin-left: 15px;
              display: inline-block;
              color: rgba(0, 177, 255, 1);
              font-size: 14px;
              border: 1px solid rgba(0, 177, 255, 1);
              border-radius: 100px;
              // width: 100px;
              padding: 0 10px;
              text-align: center;
              line-height: 25px;
              font-weight: normal;

              &:hover {
                font-weight: bold;
              }

              img {
                width: 12px;
                height: 12px;
                margin-left: 10px;
                vertical-align: middle;
              }
            }

            span {
              // margin-left: 15px;
              font-size: 12px;
              color: rgba(2, 47, 74, 0.45);
            }
          }

          > span {
            display: inline-block;
            width: 1px;
            background-color: rgba(0, 177, 255, 0.4);
            height: 80px;
            flex: none;
          }
        }
      }

      .center {
        .chart-box-wrap {
          height: 320px;
          position: relative;
        }
      }

      .bottom .chart-box-wrap {
        height: 350px;
        // height: 298px;
        margin-bottom: 30px;
      }

      .chart-box {
        height: 100%;
        width: 100%;
      }
    }

    .chart-box-wrap {
      position: relative;

      .toolbar {
        z-index: 999;
        position: absolute;
        top: 20px;
        right: 80px;

        span {
          font-size: 12px;
          cursor: pointer;
          color: #f89935;
          text-align: center;
          border: 1px solid #f89935;
          height: 23px;
          line-height: 23px;
          display: inline-block;
          width: 38px;

          &.active {
            background: #f89935;
            color: #ffffff;
          }
        }
      }
    }

    .right-content {
      flex: none;
      width: $rwidth;
      height: 100%;

      .box {
        /*padding: 20px 15px 20px 15px;*/
        position: relative;
      }

      .b1 {
        background: rgba(228, 246, 254, 0.4);
        border-radius: 6px 6px 0px 0px;

        p:first-child {
          padding-top: 10px;
          color: rgba(2, 47, 74, 1);
          font-size: 14px;
          font-family: PingFang SC;
          text-align: left;

          img {
            width: 14px;
            height: 14px;
            vertical-align: middle;
            margin-right: 5px;
            margin-left: 10px;
          }
        }

        p:nth-child(2) {
          font-size: 30px;
          font-family: Arial;
          font-weight: 400;
          color: rgba(0, 177, 255, 1);
          box-sizing: border-box;
          padding: 15px 5px 20px 5px;
        }

        > div {
          border-top: 1px solid rgba(0, 177, 255, 0.1);
          padding: 13px 0;
        }
      }

      .b2 {
        > p {
          margin-top: 30px;
          margin-bottom: 15px;
          font-size: 16px;
          font-family: PingFang SC;
          font-weight: bold;
          color: rgba(2, 47, 74, 1);
          text-align: left;

          a {
            font-size: 14px;
            float: right;
            color: rgba(2, 47, 74, 0.65);
            font-weight: 400;

            &:hover {
              text-decoration: underline;
            }
          }
        }

        li {
          text-align: left;
          box-sizing: border-box;
          padding: 0 10px;
          display: flex;
          justify-content: space-between;
          align-items: center;
          background: rgba(248, 248, 248, 1);
          color: #022f4a;
          font-size: 14px;
          font-family: PingFang SC;
          font-weight: 400;
          width: 100%;
          line-height: 40px;

          span {
            flex: auto;
            display: block;

            &:first-child {
              width: 106px;
              flex: none;
            }

            &:last-child {
              flex: none;
            }
          }
        }

        .title {
          color: rgba(2, 47, 74, 0.65);
        }

        .con {
          border-bottom: 1px solid #eeeeee;
          height: 280px;
          overflow: hidden;

          > div {
            height: 100%;
            overflow-y: auto;
          }

          li {
            // line-height: 41px;

            &:nth-child(odd) {
              background: #ffffff;
            }

            &:nth-child(even) {
              background: rgba(248, 248, 248, 1);
            }
          }
        }
      }

      .f-r {
        .box {
          display: flex;
          justify-content: space-between;
          align-items: center;
          border-bottom: 1px solid rgba(0, 177, 255, 0.1);
          font-size: 14px;
          font-family: PingFang SC;
          font-weight: 400;
          line-height: 20px;
          color: rgba(2, 47, 74, 1);
          text-align: left;

          img {
            width: 100px;
            height: 100px;
            flex: none;
            margin-right: 18px;
          }
        }

        .l-b {
          padding: 20px 0;
        }
      }
    }
  }

  .ewm-class {
    display: flex;
    font-size: 14px;
    border-bottom: 1px solid #eeeeee;
    height: 30px;
    line-height: 30px;

    .active {
      color: #00b1ff;
      font-weight: bolder;
      border-bottom: 3px solid #00b1ff;
    }
  }

  .top {
    background: #f8f8f8;

    .box {
      padding: 0 !important;

      .top-sec {
        background: #ffffff;
        border-radius: 6px;
      }

      .tl {
        width: 48%;
        height: 20vh;

        .con-top {
          margin-top: 10px;
          display: flex;
          flex-direction: column;
          justify-content: space-around;
          margin-bottom: 8px;

          .nor {
            border-radius: 3px;
            width: 365px;
            height: 194px;

            .divider {
              width: 1px;
              height: 46px;
              background: rgba(13, 181, 255, 0.2);
            }
          }

          .bz {
            background: rgba(13, 181, 255, 0.03);
            border-top: 3px solid #0db5ff;

            img {
              display: block;
              margin: 8% auto 7%;
              height: 66px;
              width: 66px;
            }

            div {
              display: inline-block;
              height: 50px;

              .num {
                font-size: 20px;
                color: #022f4a;
                line-height: 1.5;

                .fh {
                  font-size: 14px;
                }
              }

              .tips {
                color: #879eac;
                font-size: 12px;
              }
            }

            .cpkh {
              width: 43%;
              cursor: pointer;
            }

            .cpsy {
              width: 52%;
              cursor: pointer;
            }
          }

          .dz {
            background: rgba(135, 238, 223, 0.06);
            border-top: 3px solid #22e1c4;

            img {
              display: block;
              margin: 8% auto 7%;
              height: 66px;
              width: 66px;
            }

            div {
              display: inline-block;
              height: 50px;

              .num {
                font-size: 20px;
                color: #022f4a;
                line-height: 1.5;

                .fh {
                  font-size: 14px;
                }
              }

              .tips {
                color: #879eac;
                font-size: 12px;
              }
            }

            .cpkh {
              width: 43%;
              cursor: pointer;
            }

            .cpsy {
              width: 52%;
              cursor: pointer;
            }
          }
        }
      }

      .tr {
        width: 48%;
        height: 20vh;

        .con-top {
          margin-top: 10px;
          display: flex;
          justify-content: space-evenly;
          margin-bottom: 8px;

          .nor {
            border-radius: 3px;
            width: 240px;
            height: .8693rem;
            padding-top: 5.4%;

            .s-part {
              display: flex;

              img {
                margin-left: 30px;
                height: 100%;
                height: 66px;
                width: 66px;
              }

              .r-part {
                margin-left: 0.09rem;

                p {
                  line-height: 1.3;
                }

                .num {
                  text-align: left;
                  font-size: 20px;
                  color: #022f4a;

                  .fh {
                    font-size: 14px;
                  }
                }

                .tip {
                  color: #022f4a;
                  font-size: 12px;
                  text-align: left;
                }

                .ac-btn {
                  width: 0.52667rem;
                  height: 20px;
                  line-height: 20px;
                  border: 1px solid #0db5ff;
                  border-radius: 12px;
                  color: #0db5ff;
                  cursor: pointer;

                  img {
                    width: 10px;
                    height: 10px;
                    vertical-align: middle;
                    margin-left: 0;
                  }
                }
              }
            }

            .des {
              color: #879eac;
              text-align: left;
              font-size: 12px;
              margin: 0 16px 0 13px;
              line-height: 1.3;
              margin-top: 14%;
            }
          }

          .ytx {
            background: rgba(152, 128, 239, 0.05);
            border-top: 3px solid #9013fe;
          }

          .sysy {
            background: rgba(251, 160, 160, 0.05);
            border-top: 3px solid #ff9898;
          }
        }
      }
    }
  }

  .com-title .bd {
    margin-left: 10px;
  }
  .felx-betwwen{
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
</style>



// WEBPACK FOOTER //
// src/components/Index.vue